import React from "react";
const brandVoucherImage =
  "https://res.cloudinary.com/dyyjph6kx/image/upload/v1641875674/store/admin/dummy-brand-image.png";

import Typography from "@plum-xoxo/admin-dsm/core/typography/Typography";

import theme from "../../../theme";
import { Button } from "@plum-xoxo/admin-dsm";
import EditMask from "./EditMask";

const PlumProRewardBody = ({
  currencyCode = "INR",
  toggleTextModal,
  buttonText,
}) => {
  return (
    <>
      <div className="text-center">
        <img src={brandVoucherImage} alt="" width={132} />
        <Typography.BodySmall className="mt-20 mb-8" color="dark" shade="c200">
          (Brand Name) Gift Card worth
        </Typography.BodySmall>
        <Typography.DisplayText color="dark" shade="c300">
          {" "}
          {currencyCode} *****
        </Typography.DisplayText>
        <div
          style={{
            border: `1px dashed ${theme.palette.dark.c000}`,
            borderRadius: "8px",
          }}
          className="py-16 px-12"
        >
          <Typography.BodySmall color="dark" shade="c200">
            Use this code
          </Typography.BodySmall>
          <Typography.ButtonText color="dark" shade="c300" className="mt-4 ">
            ****-****-****
          </Typography.ButtonText>
          <Typography.BodySmall color="dark" shade="c200" className="mb-24">
            Pin: *******
          </Typography.BodySmall>
          <Typography.BodySmall color="dark" shade="c200">
            Expires on ******
          </Typography.BodySmall>
        </div>
        <div className="position-relative mt-16">
          <Button size="large" className="w-100 ">
            {buttonText}
          </Button>
          <EditMask
            buttonText="Button Text"
            top={0}
            toggleModalState={() => toggleTextModal()}
          />
        </div>
      </div>
    </>
  );
};

export default PlumProRewardBody;
